import React, { Dispatch, forwardRef, SetStateAction } from "react";
import { useLocation } from "react-router";
import {
  Box,
  IconButton,
  Stack,
  Tooltip,
  useMediaQuery,
  useTheme,
} from "@mui/material";
import ReactGA from "react-ga";
import { IoOpenOutline } from "react-icons/io5";
import JGIcon from "../../JGIcon";
import SelectStation from "../SelectStation";
import PlayerVolume from "./PlayerVolume";
import { DrawerToggleButton } from "../PlayerDrawer";
import { PlayerVolumeProps, PlayerProps, PlayerStateProps  } from "../types";
import PlayerSettingsButton from "../PlayerSettingsButton"
import * as S from "./PlayerActions.styles";

type PlayerActionsProps = PlayerStateProps &
  PlayerProps & PlayerVolumeProps & {
  pause: () => void;
  drawerOpen: boolean;
  setDrawerOpen: Dispatch<SetStateAction<boolean>>;
};

const PlayerActions = (props: PlayerActionsProps) => {
  const { pause, drawerOpen, setDrawerOpen } = props;
  const location = useLocation();
  const theme = useTheme();
  const isDesktop = useMediaQuery(theme.breakpoints.up("lg"));
  const isMobile = useMediaQuery(theme.breakpoints.down("md"));
  const isFreeTrial =
    window.location.pathname.slice(1) === "free" ||
    window.location.pathname.slice(1) === "freetrial";

  return (
    <>
      <Stack
        spacing={1}
        direction="row"
        sx={{ pr: 1 }}
      >
        {!(isMobile && !drawerOpen) && (
        <PlayerSettingsButton {...props} />
        )}
        {!(isMobile && !drawerOpen) &&  (
        <PlayerVolume {...props} />)}
        {!isFreeTrial && isDesktop && (
          <Tooltip title="Open in pop-up">
            <IconButton
              aria-label="Open player in pop-up"
              onClick={(e) => {
                e.preventDefault();
                pause();
                ReactGA.event({
                  category: "player",
                  action: "popup",
                });
                window.open(
                  "/stream" + location.search,
                  "stream",
                  "scrollbars=no,resizable=no,status=no,location=no,toolbar=no,menubar=no,width=500,height=700,left=100,top=100"
                );
              }}
            >
              <JGIcon
                is={IoOpenOutline}
                fontSize={isDesktop ? "medium" : "small"}
              />
            </IconButton>
          </Tooltip>
        )}
      </Stack>
      {isMobile && !drawerOpen && (
        <DrawerToggleButton
          open={drawerOpen}
          setOpen={setDrawerOpen}
          sx={{ opacity: undefined }}
        />
      )}
      {!isMobile && (
        <SelectStation
          MenuProps={{
            anchorOrigin: { vertical: "top", horizontal: "center" },
            transformOrigin: { vertical: "bottom", horizontal: "center" },
          }}
        />
      )}
    </>
  );
};

const PlayerActionsContainer = forwardRef<typeof Box, PlayerActionsProps>(
  (props, ref) => {

    return (
      <Box
        ref={ref}
        className={S.classes.root}
        sx={{
          flex: {
            xs: 0,
            md: 1,
          },
          alignItems: "center",
          height: "100%",
        }}
      >
        <S.Content spacing={1} direction="row">
          <PlayerActions {...props} />
        </S.Content>
      </Box>
    );
  }
);

export default PlayerActionsContainer;
